import {defineMessages} from 'react-intl';

export default defineMessages({
	label: {
		id: 'forms.fields.phoneNumber.label',
		defaultMessage: 'Phone Number'
	},
	placeholder: {
		id: 'forms.fields.phoneNumber.placeholder',
		defaultMessage: 'Month'
	},
	tip: {
		id: 'forms.fields.phoneNumber.tip',
		defaultMessage: 'In case we need to contact you for your order'
	},
	lengthError: {
		id: 'forms.fields.phoneNumber.error.length',
		defaultMessage: 'Phone number must be between {minLength} and {maxLength} characters'
	},
	invalidError: {
		id: 'forms.fields.phoneNumber.error.length',
		defaultMessage: 'Please enter a valid phone number'
	},
	phoneCodeExtendedLabel: {
		id: 'forms.fields.phoneCode.extended.label',
		defaultMessage: 'Country of caller',
	},
	phoneCodeLabel: {
		id: 'forms.fields.phoneCode.label',
		defaultMessage: 'Prefix',
	},
	phoneLabel: {
		id: 'forms.fields.phone.label',
		defaultMessage: 'Telephone',
	},
});